<template>
  <ul class="scout-events">
    <li
      class="scout-event flex-center-vertical"
      v-for="(event, index) in events"
      :key="index">
      <p class="time color-important">
        {{ event.time }}
      </p>
      <p class="text-cut">
        <i
          class="n-i icon"
          :class="`n-i-${event.icon}`"
          v-if="event.icon"
        />
        <span>{{ event.title }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import { reverse, slice } from 'lodash';

export default {
  name: 'ScoutEvents',
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
  },
  computed: {
    events() {
      const events = this.$store.getters.getScoutEvents(this.idMatch);
      return reverse(slice(events, -5));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.scout-events {
  float: left;
  height: 30vh;
  width: 100%;
  color: $color-text-primary;
  background-color: $match-color-back-even;
  border-top: 1px solid $row-color-border;
  border-bottom: 1px solid $row-color-border;
  font-size: 0.875rem;
}

.scout-event {
  height: 6vh;
  padding: 0 20px;
  border-bottom: 1px solid $row-color-border;
}

.time {
  flex-shrink: 0;
  width: $scout-time-width;
}

.icon {
  font-size: 0.75rem;
  padding-right: 10px;

  &.icon-yellow { color: $match-card-yellow; }
  &.icon-red { color: $match-card-red; }
}
</style>
